import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'

export { default as filterByQuery } from './query'

// ---- Data Management ----
export const getters = (...getterNames) => mapGetters([
  // auth & user
  'authUser',
  'hasRole',
  'isAuth',

  // state
  'isLoaded',
  'query',
  'queryOne',

  // i18n
  'locale',

  ...getterNames,
])

export const actions = (...actionNames) => mapActions([
  // loaders
  'LOAD',
  'POST_LOAD',

  // error reporting
  'ERROR',

  // alerts
  'SUCCESS',

  // event binding
  'ON',

  ...actionNames,
])

/*
  Adds global components. Expects components in the same form as
  vm.components. For example: { OneComponent, SomeOtherComponent }.
*/
export const registerComponents = components => Object
  .keys(components)
  .filter(componentName => !Vue.options.components[componentName])
  .forEach(componentName => Vue.component(
    componentName,
    components[componentName],
  ))
